<template>
  <div class="flex-shrink-0 pt-2 pb-2">
    <div class="d-flex flex-column">
      <RouterLink class="sidebar_item arrow" to="/">トップページ</RouterLink>
      <div class="sidebar_title">
        <span>記事</span>
      </div>
      <div class="sidebar_wraper d-flex flex-column">
        <RouterLink
          class="sidebar_item arrow"
          to="/searchArticle"
          active-class="active_sidebar_item"
          >記事検索
        </RouterLink>
        <RouterLink
          class="sidebar_item arrow"
          to="/articleInput/"
          v-bind:class="{ active_sidebar_item: isActiveRoute('/articleInput') }"
          >記事編集</RouterLink
        >
      </div>
      <div class="sidebar_title">
        <span>YouTube</span>
      </div>
      <RouterLink
        class="sidebar_item arrow"
        to="/searchYouTube"
        active-class="active_sidebar_item"
        >YouTube検索
      </RouterLink>
      <RouterLink
        class="sidebar_item arrow"
        to="/youtubeInput"
        v-bind:class="{ active_sidebar_item: isActiveRoute('/youtubeInput') }"
        >YouTube編集</RouterLink
      >
      <div class="sidebar_title">
        <span></span>
      </div>
      <RouterLink
        class="sidebar_item arrow"
        to="/predictiveInput/"
        v-bind:class="{
          active_sidebar_item: isActiveRoute('/predictiveInput'),
        }"
        >予想入力</RouterLink
      >
      <RouterLink
        class="sidebar_item arrow"
        to="/specialSite"
        active-class="active_sidebar_item"
        >ピックアップ</RouterLink
      >
      <RouterLink
        class="sidebar_item arrow"
        to="/ranking"
        active-class="active_sidebar_item"
        >アクセスランキング</RouterLink
      >
      <RouterLink
        class="sidebar_item arrow"
        to="/CSVupload"
        active-class="active_sidebar_item"
        >CSVアップロード</RouterLink
      >
      <RouterLink
        v-if="hasPermission(roleStore.role, 'XML_DOWNLOAD')"
        class="sidebar_item arrow"
        to="/XMLManualUpdate"
        active-class="active_sidebar_item"
        >XML随時取得</RouterLink
      >
      <RouterLink
        class="sidebar_item arrow"
        to="/MaintenanceDisplay"
        active-class="active_sidebar_item"
        >メンテナンス中設定
      </RouterLink>
      <RouterLink
        v-if="hasPermission(roleStore.role, 'ADMIN')"
        class="sidebar_item arrow"
        to="/users"
        active-class="active_sidebar_item"
        >ユーザー管理
      </RouterLink>
    </div>
  </div>
</template>

<script setup>
import useRole from "@/components/role";
import { useRoleStore } from "@/store/roleStore";
const roleStore = useRoleStore();
import { useRoute } from "vue-router";
const { hasPermission } = useRole();
import { computed } from "vue";

const route = useRoute();

const color = computed(() => {
  return process.env.VUE_APP_ENV_COLOR;
});

const isActiveRoute = (path) => {
  return route.path.startsWith(path);
};
</script>

<style scoped>
.sidebar_item {
  margin: 0.3rem 0.3rem 0 0.3rem;
  padding: 0.2rem 0;
  background: #b8d3dc;
  width: 95%;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  padding-left: 0.5rem;
  color: #626262;
  font-weight: bold;
}

.sidebar_item a {
  margin-left: 0.5rem;
  text-decoration: none;
  color: #5d5d5d;
  font-weight: bold;
  width: 9.5rem;
}

.sidebar_item::before,
.sidebar_item::after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 11.5rem;
  margin: auto;
  content: "";
  vertical-align: middle;
}

.sidebar_item::after {
  content: "";
  width: 0.5rem;
  height: 0.5rem;
  border-top: 2px solid v-bind(color);
  border-right: 2px solid v-bind(color);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.sidebar_item:hover {
  opacity: 0.5;
}

.sidebar_title {
  border-bottom: 2px solid #86dee7;
  margin: 0.3rem 0.3rem 0 0.3rem;
}

.sidebar_title span {
  color: #5d5d5d;
  font-size: 0.7rem;
  font-weight: bold;
  padding-left: 0.8rem;
}

ol,
ul {
  padding-left: 0.8em !important;
}

.btn-toggle[aria-expanded="true"] {
  color: rgba(var(--bs-emphasis-color-rgb), 0.85);
}

.btn-toggle[aria-expanded="true"]::before {
  transform: rotate(90deg);
}

.btn-toggle-nav a {
  padding: 0.1875rem 0.5rem;
  margin-top: 0.125rem;
  margin-left: 1.25rem;
}

.btn-toggle-nav a:hover,
.btn-toggle-nav a:focus {
  background-color: var(--bs-tertiary-bg);
}

li {
  list-style: none;
}

.active_sidebar_item {
  background: v-bind(color);
  /* 任意の色に設定します */
  color: #fff;
}
</style>
